import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8b73ce6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "toolbar",
  class: "b-0 l-0 w-full h-48 p-8 bg-black bg-opacity-25 backdrop-blur-sm flex items-center flex-row justify-between"
}
const _hoisted_2 = {
  id: "left",
  class: "flex gap-4"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-1 bg-white bg-opacity-50 rounded-lg" }, null, -1))
const _hoisted_4 = {
  id: "center",
  class: "flex"
}
const _hoisted_5 = {
  id: "right",
  class: "flex"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Colors = _resolveComponent("Colors")!
  const _component_Tools = _resolveComponent("Tools")!
  const _component_Frames = _resolveComponent("Frames")!
  const _component_Settings = _resolveComponent("Settings")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Colors),
      _hoisted_3,
      _createVNode(_component_Tools)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Frames)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Settings)
    ])
  ]))
}